import { Component, ElementRef, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { fromEvent, merge, Observable, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { User } from 'src/app/db/models/user';
import { GenericValidator } from 'src/app/directives/generic-validator';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {

  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];

  title = 'Basic Information';

  sform: FormGroup;

  user = new User();
  private sub: Subscription;


  displayMessage: { [key: string]: string } = {};
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;

  constructor(private fb: FormBuilder,
        private router: Router,
        private service: UserService)
        {
          this.validationMessages = {
          firstname: {
            required: 'firstname is required'
          },
          lastname: {
            required: 'lastname is required'
          },
          contact: {
            required: 'A working mobile contact is required'
          },
          address: {
            required: 'A valid address is required'
          },
          email:{
            email: 'Please enter a valid email address'
          },
           username:{
            required: 'Please specify username'
          },
          passord:{
            required: 'Please enter a valid password'
          }
        }

          this.genericValidator = new GenericValidator(this.validationMessages);
        }

  ngOnInit() {

    this.createDataForm();

  }

  createDataForm(){
    this.sform = this.fb.group({
      firstname: [null, Validators.required],
      lastname: [null, Validators.required],
      contact: [null, Validators.required],
      address: [null, Validators.required],
      email: [null, Validators.email],
      username: [null, Validators.required],
      password: [null, Validators.required],
    })
  }

  ngAfterViewInit(): void {
    const controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));
    merge(this.sform.valueChanges, ...controlBlurs).pipe(
      debounceTime(800)
    ).subscribe(value => {
      this.displayMessage = this.genericValidator.processMessages(this.sform);
    });
  }


  get firtsname(){
    return this.sform.controls.firstname as FormControl;
  }

  get lastname(){
    return this.sform.controls.lastname as FormControl;
  }

  get contact(){
    return this.sform.controls.contact as FormControl;
  }

  get address(){
    return this.sform.controls.address as FormControl;
  }

  get email(){
    return this.sform.controls.email as FormControl;
  }

  get username() {
    return this.sform.controls.username as FormControl;
  }

  get password() {
    return this.sform.controls.password as FormControl;
  }


  mapEntity(): void {
    this.user.firstname = this.firtsname.value;
    this.user.lastname = this.lastname.value;
    this.user.contact = this.contact.value;
    this.user.address = this.address.value;
    this.user.email  = this.email.value;
    this.user.username = this.username.value;
    this.user.password = this.password.value;
  }

  saveData(){
    if(this.sform.valid){
      this.mapEntity();
      console.log('New Service', this.user);
      if (this.user.id == null) {
        this.service.addUser(this.user)
        .subscribe({
          next: () => {
            this.successNotification();

          },
          error: err => {
            this.errorNotification();

          }
        })
      }
    }
  }

  successNotification(){
    Swal.fire({
      icon: 'info',
      title: 'Great!',
      text:'Registration Successful',
      showDenyButton: false,
      focusConfirm: true,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Ok',
    }).then((result) => {
      if(result.isConfirmed){
        this.abort();
      }
    })
  }

  errorNotification(){
    Swal.fire({
      icon: 'error',
      title: 'Oops',
      text: 'Something went wrong!!!',
      showDenyButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-repeat"></i> Try Again!',
      denyButtonText: `<i class="fa fa-power-off"></i> Cancel`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.reload();
      } else {
        this.abort();
      }
    })
  }

  abort(){
     this.router.navigate(['login']);
    }

  reload(){
     this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
       this.router.navigate(['sign_up']);
     })
    }

}
